import request from '@/utils/request'

let ServeApi = {

  /*服务列表*/
  list(data) {
    return request._post('/shop/plus.serve.Index/index', data);
},
/*添加服务*/
add(data) {
    return request._post('/shop/plus.serve.Index/add', data);
},
/*修改服务*/
edit(data) {
    return request._post('/shop/plus.serve.Index/edit', data);
},
/*删除服务*/
del(data) {
    return request._post('/shop/plus.serve.Index/del', data);
},
/*服务详情*/
detail(data) {
  return request._post('/shop/plus.serve.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.serve.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.serve.Setting/getSetting', data, errorback);
    },

    importData(data) {
        return request._post('/shop/plus.serve.Index/import', data);
    },
    exportExcel(data) {
        return request._post('/shop/plus.serve.Index/export', data);
    },

/*服务记录列表*/
  lists(data) {
    return request._post('/shop/plus.serve.Record/index', data);
},
/*删除服务记录*/
delete(data) {
    return request._post('/shop/plus.serve.Record/del', data);
},
/*审核服务记录*/
audit(data) {
    return request._post('/shop/plus.serve.Record/audit', data);
},


}
export default ServeApi;



// WEBPACK FOOTER //
// ./src/api/serve.js